<script>
  import {
    afterUpdate,
    beforeUpdate,
    createEventDispatcher,
    onMount,
    tick,
  } from "svelte";
  import * as Hotkeys from "../util/hotkeys.js";
  import * as History from "../util/history.js";
  // import { fly, slide } from "svelte/transition";
  import Button from "./Button.svelte";
  import FastGallery from "./FastGallery.svelte";
  import { encodingToHex, hexToEncoding } from "bitframes";
  // import ArtworkThumb from "./ArtworkThumb.svelte";
  import { downloadBlob, getTimestamp } from "../util/save.js";
  // import closeIcon from "../assets/icons/close-big.svg";

  export let encoding = null;
  export let viewMode = "gallery";
  export let filterFavs = false;
  export let showToolbar = true;

  const dispatch = createEventDispatcher();

  let usingFavs = false;
  updateFavs();
  function updateFavs() {
    // usingFavs = window.innerWidth > 500;
  }

  let gallery;
  let curEncodingHex;
  $: curEncodingHex = encoding ? encodingToHex(encoding) : null;

  let raf;
  // let firstScroll = true;

  let scrollCache = {
    filter: null,
    default: null,
  };

  function cachedScrollOfFilterMode() {
    return scrollCache[filterFavs ? "filter" : "default"];
  }

  // async function saveScroll() {
  //   const newScroll = getScroll();
  //   if (filterFavs) {
  //     oldScrolls.filter = newScroll;
  //   } else {
  //     oldScrolls.default = newScroll;
  //   }
  //   console.log("prev", newScroll, filterFavs);
  //   await tick();
  //   let next = filterFavs ? oldScrolls.filter : oldScrolls.default;
  //   console.log("next", next, filterFavs);
  //   if (next == null) scrollToBottom();
  //   else if (contentContainer) {
  //     contentContainer.scrollTop = next;
  //   }
  // }

  let list = [];
  // let listDidChange = false;
  // $: list, console.log("LIST CHANGE");

  let removeButtonEnabled = true;
  let contentContainer;
  let filterFavsEnabled = true;
  let delButtonEnabled = true;
  let filteredFavList = [];
  const unsub = History.store.subscribe((v) => {
    const oldList = filterFavs ? filteredFavList : list;

    list = v.slice(0, History.getMaxCount());
    filteredFavList = list.filter((f) => f[1] === true);
    filterFavsEnabled = filteredFavList.length > 0;

    const newList = filterFavs ? filteredFavList : list;

    if (newList.length > oldList.length) {
      requestScroll("selected");
    }
  });

  $: {
    const newList = filterFavs ? filteredFavList : list;
    delButtonEnabled = newList.find((f) => f[0] === curEncodingHex);
    removeButtonEnabled = newList.length > 0;
  }

  // afterUpdate(() => {
  //   // updateFrame();
  //   // console.log("needsUpdate");
  //   let doScroll = listDidChange;
  //   if (list.length > 0) {
  //     const last = list[list.length - 1];
  //     // if the cur element isn't last, we don't need to scroll to bottom
  //     if (curEncodingHex !== last && !firstScroll) {
  //       doScroll = false;
  //     }
  //   }
  //   if (doScroll) {
  //     requestAnimationFrame(() => scrollToBottom("smooth"));
  //     firstScroll = false;
  //   }
  //   listDidChange = false;
  // });

  onMount(() => {
    const destroyHotkey0 = Hotkeys.mount("delete", () => {
      if (
        delButtonEnabled &&
        window.confirm("Remove this encoding from the history?")
      ) {
        History.remove(curEncodingHex);
      }
    });
    const destroyHotkey1 = Hotkeys.mount("backspace", () => {
      if (
        delButtonEnabled &&
        window.confirm("Remove this encoding from the history?")
      ) {
        History.remove(curEncodingHex);
      }
    });

    // console.log("mount", getScroll());
    requestScroll("selected");
    return () => {
      destroyHotkey0();
      destroyHotkey1();
      unsub();
      cancelAnimationFrame(raf);
    };
  });

  afterUpdate(() => {
    const scroll = getScroll();
    scrollCache[filterFavs ? "filter" : "default"] = scroll;
    console.log("got scroll", scroll);
  });

  function requestScroll(type) {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      if (type === "selected") {
        if (gallery) {
          const el = gallery.findElement(curEncodingHex);
          if (el && el.scrollIntoView) el.scrollIntoView();
        }
      } else if (type === "bottom") {
        scrollToBottom();
      } else if (type === "previous") {
        const top = cachedScrollOfFilterMode();
        contentContainer.scrollTo({
          top,
          behavior: "instant",
        });
      }
    });
  }

  function getScroll() {
    return contentContainer ? contentContainer.scrollTop : 0;
  }

  function scrollToBottom(behavior = "instant") {
    if (contentContainer) {
      const newTop =
        contentContainer.scrollHeight - contentContainer.clientHeight;
      const curTop = contentContainer.scrollTop;
      const delta = Math.abs(curTop - newTop);
      if (delta > 2) {
        contentContainer.scrollTo({
          top: newTop,
          behavior: "instant",
        });
      }
    }
  }

  function keyUp(ev) {}

  function keyDown(ev) {}

  function markFavorite(enc) {}

  async function exportHistory() {
    const data = list
      .map((n) => {
        let enc,
          fav = false;
        if (typeof n === "string") enc = n;
        else {
          enc = n[0];
          fav = Boolean(n[1]);
        }

        try {
          return [encodingToHex(hexToEncoding(enc)), fav ? "1" : "0"].join(",");
        } catch (err) {
          return false;
        }
      })
      .filter(Boolean)
      .join("\n");
    const filename = `history-` + getTimestamp() + ".csv";
    const blob = new Blob([data], { type: "text/csv" });
    clearState();
    await downloadBlob(blob, { filename });
  }

  async function readFileAsText(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const txt = reader.result;
        resolve(txt);
      };
      reader.onerror = () => {
        reject(new Error(`Could not read ${file.name}`));
      };
      reader.readAsText(file);
    });
  }

  async function importHistory(files) {
    const file = files[0];
    try {
      const text = (await readFileAsText(file)).trim();
      if (text.length === 0) return alert("File is empty");
      const lines = text.split("\n").map((n) => {
        n = n.trim();
        return n;
      });

      const newList = [];
      for (let line of lines) {
        try {
          let fav = false;
          let enc = "";
          if (line.includes(",")) {
            const d = line.split(",");
            enc = d[0].trim();
            fav = d[1].trim() == "1" ? true : false;
          } else {
            enc = line;
          }

          const hex = encodingToHex(hexToEncoding(enc));
          const match = newList.find((n) => {
            return n[0] === hex;
          });
          if (!match) {
            newList.push([enc, fav]);
          }
        } catch (_) {
          throw new Error(
            `Must be a CSV file where every line is a valid 32-byte hex encoding`
          );
        }
      }

      if (newList.length === 0) throw new Error("No valid items");
      if (newList.length > History.MAX_AMOUNT)
        newList.length = History.MAX_AMOUNT;
      History.update(() => newList);

      const last = newList[newList.length - 1][0];
      dispatch("change", hexToEncoding(last));
      requestAnimationFrame(() => scrollToBottom("instant"));
      clearState();
    } catch (err) {
      alert(err.message);
    }
  }

  function clearState() {
    filterFavs = false;
  }

  function slider(node, { duration = 1000 } = {}) {
    return {
      duration,
      css: (t) => {
        return `margin-right: ${t * 100}px`;
        // const eased = elasticOut(t);
        // return `
        // 	transform: scale(${eased}) rotate(${eased * 1080}deg);
        // 	color: hsl(
        // 		${Math.trunc(t * 360)},
        // 		${Math.min(100, 1000 * (1 - t))}%,
        // 		${Math.min(50, 500 * (1 - t))}%
        // 	);`;
      },
    };
  }
</script>

<svelte:window on:resize|nonpassive={updateFavs} />

<div class="container" role="none" on:keyup={keyUp} on:keydown={keyDown}>
  {#if showToolbar}<div class="toolbar">
      <!-- <Button
      xsmall
      text="DEL"
      enabled={delButtonEnabled}
      showHotkey={false}
      hotkey="delete"
      on:click={() => {
        History.remove(curEncodingHex);
      }}
    /> -->

      {#if usingFavs}<Button
          xsmall
          radio
          toggled={filterFavs}
          text="FAV"
          hideOnMobile
          enabled={filterFavsEnabled}
          on:click={async (ev) => {
            // save scroll
            scrollCache[filterFavs ? "filter" : "default"] = getScroll();
            // do change
            filterFavs = ev.detail.toggled;
            // wait and then apply
            await tick();
            const cached = cachedScrollOfFilterMode();
            if (contentContainer && cached != null) {
              contentContainer.scrollTop = cached;
            }
          }}
        />{/if}
      <!-- <Button
        xsmall
        radio
        fitHeight
        toggled={filterFavs}
        hideOnMobile
        text="Delete"
        enabled={filterFavsEnabled}
        on:click={async (ev) => {
          // save scroll
          scrollCache[filterFavs ? "filter" : "default"] = getScroll();
          // do change
          filterFavs = ev.detail.toggled;
          // wait and then apply
          await tick();
          const cached = cachedScrollOfFilterMode();
          if (contentContainer && cached != null) {
            contentContainer.scrollTop = cached;
          }
        }}
      /> -->
      <!-- <Button
      xsmall
      text="REMOVE"
      enabled={removeButtonEnabled}
      on:click={async (ev) => {
        const indexInHistory = list.findIndex(
          (enc) => curEncodingHex === enc[0]
        );
        if (indexInHistory === -1) return;

        if (true) {
          const curList = filterFavs ? filteredFavList : list;
          const indexInCurrentView = curList.findIndex(
            (enc) => curEncodingHex === enc[0]
          );
          let neighborIdx = -1;
          if (indexInCurrentView > 0) neighborIdx = indexInCurrentView - 1;
          else if (indexInCurrentView < curList.length - 1)
            neighborIdx = indexInCurrentView + 1;

          // if (neighborIdx)

          History.update((list) => {
            list = list.slice();
            list.splice(indexInHistory, 1);
            return list;
          });
          // const next;
          // dispatch("change", hexToEncoding(last));
        }
      }}
    /> -->
      <div class="toolbar-spacer"></div>

      <Button
        xsmall
        fitHeight
        fileInput
        hideOnMobile={false}
        text="Import CSV"
        on:select={async (ev) => {
          const { files, reset } = ev.detail;
          if (
            files.length &&
            (list.length > 0
              ? window.confirm(
                  "This will replace all your history, are you sure?"
                )
              : true)
          ) {
            await importHistory(files);
          }
          reset();
        }}
      />
      <Button
        xsmall
        fitHeight
        hideOnMobile={false}
        text="Export CSV"
        enabled={list.length > 0}
        on:click={() => {
          console.log("CLICK!");
          exportHistory();
        }}
      />
      <Button
        fitHeight
        xsmall
        text="Clear"
        enabled={list.length > 0}
        on:click={() => {
          if (
            window.confirm(
              "Are you sure you want to clear the history of all created encodings?"
            )
          ) {
            History.clear();
            clearState();
          }
        }}
      />
    </div>{/if}

  <div class="gallery" bind:this={contentContainer}>
    <FastGallery
      {usingFavs}
      bind:this={gallery}
      encodings={filterFavs ? filteredFavList : list}
      encoding={curEncodingHex}
      on:favorite={(ev) => {
        const enc = ev.detail;
        const hex = typeof enc === "string" ? enc : encodingToHex(enc);
        History.toggleFavorite(hex);
      }}
      on:select={(ev) => {
        dispatch("change", hexToEncoding(ev.detail));
      }}
    />
  </div>
</div>

<style>
  .container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    position: relative;
  }
  .toolbar {
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 5px;
    align-items: center;
    padding: 7.5px;
    height: 35px;
    box-sizing: border-box;
    border-bottom: 1px dashed black;
    /* display: none; */
  }
  .toolbar-spacer {
    flex-grow: 1;
  }

  .gallery {
    overflow-y: auto;
    overflow-x: hidden;
    flex-grow: 1;
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width: 720px) {
    /* .toolbar {
      display: none;
    } */
  }
</style>
